import { Helmet } from 'react-helmet';
import {
  Button,
  Card,
  Loader, ModalWindow, QuickSelectionV2, Select,
  Table,
  Checkbox,
} from '~/components';
import { AdminLayout } from '../AdminLayout';
import { FaultsLayout } from '../FaultsLayout';
import { useStateVar } from '~/helpers/useStateVar';
import { LoaderContainer } from '../FaultsDisable/styles';
import { Box, Flex } from 'reflexbox';
import { t } from 'i18next';
import moment from 'moment';
import {
  BulkActionBar,
  ButtonOptions,
  ClearBtn,
  Container,
  ContainerArrowLeft, ContainerArrowRight, ContainerButtonStatusOpen, ContainerModal, ContainerModalInputs, ContentDate, Icon, LabelData,
  LoaderOverlay,
  ModalCancel,
  ModalSubTitle,
  ModalText,
  ModalTextTitle,
  ModalTitle,
  OptionsButtonsStatus,
  ProgressBarFill,
  ProgressBarTrack,
  ProgressModal,
  ProgressOverlay,
  StyledBox,
  StyledLink,
} from './styles';
import {
  AlertApproved,
  Approved,
  ArrowDownAnalisys,
  ArrowLeftIcon, ArrowRightIcon, AwaitingApproved, ColumnIcon, ExportIcon, NewApiIcon,
  Reproved,
} from '~/icons';
import { SingleDatePicker, DateRangePicker } from 'react-dates';
import { NoApiReturn, TableWrapper } from '../Integrations/ApiIntegrations/styles';
import { GenerateItemColumn } from '~/components/Table';
import { useEffect, useState } from 'react';
import ModalOrderColumns from '~/components/ModalOrderColumns';
import { controlColumnsConfigs } from './TableConfigs';
import { ColumnTable } from '~/metadata/ColumnTable.model';
import { reorderList } from '~/helpers/reorderList';
import { DateLabel, StringLabel } from '~/pages/General/TableConfigs';
import { apiCall } from '~/providers';
import { formatHealthIcon, formatLabelHealth } from '~/components/HealthIcon';
import { toast } from 'react-toastify';
import { TextArea } from '~/components/NewInputs/TextArea';
import { getUserProfile } from '~/helpers/userProfile';
import Pagination from 'rc-pagination';
import OlhoAberto from '~/icons/OlhoAberto';
import { colors } from '~/styles/colors';

interface WorkOrder {
  CLIENT_ID: number;
  CLIENT_NAME: string;
  UNIT_NAME: string;
  UNIT_ID_API: string;
  MACHINE_NAME: string;
  ASSET_ID: number;
  ASSET_NAME: string;
  DEVICE_CODE: string;
  HEALTH_DESC: string;
  HEALTH_INDEX: number;
  DAT_REPORT: number;
  WORK_ORDER_HIST_ID: string;
  WORK_ORDER_HIST_STATE_ID: number;
  WORK_ORDER_HIST_ASSET_ID: number;
  WORK_ORDER_HIST_FAULT_INDEX: number;
  WORK_ORDER_HIST_FAULT_NAME: string;
  WORK_ORDER_HIST_WO_CODE?: string;
  WORK_ORDER_HIST_CREATED_WO?: Date;
  WORK_ORDER_HIST_CLOSED_WO?: Date;
  WORK_ORDER_HIST_UPDATED_AT: Date;
}

const HealthCell = (index) => (
  <StyledBox health={index}>
    <Icon>
      {formatHealthIcon(index)}
    </Icon>
    {formatLabelHealth(index)}
  </StyledBox>
);

export function formatLabelStatus(status?: number): string {
  switch (status) {
    case 1: return t('alertaPendente');
    case 2: return t('alertaAprovado');
    case 3: return t('osAberta');
    case 4: return t('manutencaoPendente');
    case 5: return t('manutencaoAprovada');
    case 6: return t('manutencaoRejeitada');
    case 7: return t('osConcluida');
    case 8: return t('osCancelada');
    case 9: return t('osFechadaPeloCliente');
    case 10: return t('osFechadaApenasParaDiel');
    default: return t('');
  }
}

function IconStatus(status: number) {
  switch (status) {
    case 1: return <AwaitingApproved color="#767676" size={15} />;
    case 2: return <AlertApproved color="#363BC4" size={15} />;
    case 3: return <AlertApproved color="#363BC4" size={15} />;
    case 4: return <AlertApproved color="#363BC4" size={15} />;
    case 5: return <AlertApproved color="#363BC4" size={15} />;
    case 6: return <AlertApproved color="#363BC4" size={15} />;
    case 7: return <Approved size={15} />;
    case 8: return <Reproved size={15} />;
    case 9: return <AlertApproved color="#363BC4" size={15} />;
    case 10: return <AlertApproved color="#363BC4" size={15} />;
    default: return '';
  }
}

const StatusCell = (index) => (
  <div style={{
    display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '5px',
  }}
  >
    {IconStatus(index)}
    {formatLabelStatus(index)}
  </div>
);

export const OptionsButtonStatusAlert = ({
  id, dat, isOpen, handleButtonStatusToggle, status, onActivateClick, data,
}) => {
  const getInitialButtonState = () => {
    switch (status) {
      case 1: return 'pendente';
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 9:
      case 10:
      case 7: return 'aprovado';
      case 8: return 'reprovado';
      default: return 'pendente';
    }
  };

  const [buttonState, setButtonState] = useState(getInitialButtonState());

  const handleApproval = async () => {
    try {
      await onActivateClick(id, 'APPROVED', data);
      setButtonState('aprovado');
    } catch {
      toast.error(`${t('houveErro')}: ${data.DEVICE_CODE}`);
    }
  };

  const handleRejection = async () => {
    try {
      await onActivateClick(id, 'REJECTED', data);
      setButtonState('reprovado');
    } catch {
      toast.error(`${t('houveErro')}: ${data.DEVICE_CODE}`);
    }
  };

  const renderContent = () => {
    switch (buttonState) {
      case 'pendente':
        return status === 1 ? (
          <>
            <ButtonOptions
              style={{ borderRadius: '4px', width: '110px', position: 'relative' }}
              onClick={() => handleButtonStatusToggle(dat)}
            >
              <p style={{ margin: '0%' }}>Pendente</p>
              <ArrowDownAnalisys />
            </ButtonOptions>
            {isOpen && (
              <ContainerButtonStatusOpen>
                <OptionsButtonsStatus
                  style={{ width: '100%', height: '100%' }}
                  disabled={false}
                  onClick={handleApproval}
                >
                  <Approved size={15} />
                  <p style={{ margin: '0%', marginLeft: '10px' }}>Aprovar</p>
                </OptionsButtonsStatus>
                <OptionsButtonsStatus
                  style={{ width: '100%', height: '100%' }}
                  disabled={false}
                  onClick={handleRejection}
                >
                  <Reproved size={15} />
                  <p style={{ margin: '0%', marginLeft: '10px' }}>Reprovar</p>
                </OptionsButtonsStatus>
              </ContainerButtonStatusOpen>
            )}
          </>
        ) : null;
      case 'aprovado':
        return (
          <div style={{
            display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '5px',
          }}
          >
            <Approved size={15} />
            <p style={{ margin: '0%' }}>Aprovado</p>
          </div>
        );
      case 'reprovado':
        return (
          <div style={{
            display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '5px',
          }}
          >
            <Reproved size={15} />
            <p style={{ margin: '0%' }}>Reprovado</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {renderContent()}
      {isOpen && buttonState === 'pendente' && status === 1 && (
        <button
          style={{
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            position: 'fixed',
            zIndex: 10,
            background: 'transparent',
            border: 'none',
            padding: 0,
          }}
          onClick={() => handleButtonStatusToggle(dat)}
          aria-label={`Toggle status for ID: ${dat}`}
          type="button"
        />
      )}
    </div>
  );
};

export const OptionsButtonStatusWO = ({
  id,
  isOpen,
  handleButtonStatusToggle,
  status,
  onActivateClick,
}) => {
  if (status <= 2) return null;

  switch (status) {
    case 3:
      return <p>{t('aguardandoManutencao')}</p>;
    case 4: // Manutenção pendente
    case 9: // OS fechada apenas para o cliente
      return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <ButtonOptions
            style={{ borderRadius: '4px', width: '110px', position: 'relative' }}
            onClick={() => handleButtonStatusToggle(id)}
          >
            <p style={{ margin: '0%' }}>Pendente</p>
            <ArrowDownAnalisys />
          </ButtonOptions>

          {isOpen && (
            <>
              <ContainerButtonStatusOpen>
                <OptionsButtonsStatus
                  style={{ width: '100%', height: '100%' }}
                  disabled={false}
                  onClick={() => {
                    onActivateClick(id, 5);
                  }}
                >
                  <Approved />
                  <p style={{ margin: '0%', marginLeft: '10px' }}>Aprovar</p>
                </OptionsButtonsStatus>
                <OptionsButtonsStatus
                  style={{ width: '100%', height: '100%' }}
                  disabled={false}
                  onClick={() => {
                    onActivateClick(id, 6);
                  }}
                >
                  <Reproved />
                  <p style={{ margin: '0%', marginLeft: '10px' }}>Rejeitar</p>
                </OptionsButtonsStatus>
              </ContainerButtonStatusOpen>
              <button
                style={{
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  position: 'fixed',
                  zIndex: 10,
                  background: 'transparent',
                  border: 'none',
                  padding: 0,
                }}
                onClick={() => handleButtonStatusToggle(id)}
                aria-label={`Toggle status for ID: ${id}`}
                type="button"
              />
            </>
          )}
        </div>
      );
    case 5:
      return <p>Manutenção Aprovada</p>;
    case 6:
      return <p>Manutenção Reprovada</p>;
    case 7:
      return <p>Concluído</p>;
    case 8:
      return <p>Cancelado</p>;
    case 10:
      return <p>{t('osFechadaApenasParaDiel')}</p>;
    default:
      return null;
  }
};

const WorkOrderCreatedCell = ({ value }) => (
  value ? DateLabel(value, 'WORK_ORDER_HIST_CREATED_WO') : <div />
);

const WorkOrderUpdatedCell = ({ value }) => (
  value ? DateLabel(value, 'WORK_ORDER_HIST_UPDATED_WO') : <div />
);

const WorkOrderClosedCell = ({ value }) => (
  value ? DateLabel(value, 'WORK_ORDER_HIST_CLOSED_WO') : <div />
);

export const FaultsApi = (): JSX.Element => {
  const [controlColumns, setControlColumns] = useState<{
    id: string;
    visible: boolean;
    label: string;
  }[]>([]);
  const [profile] = useState(getUserProfile);
  const [textComment, setTextComment] = useState<string>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bulkRejectModal, setBulkRejectModal] = useState<{ open: boolean; type: 'alert' | 'maintenance' }>({ open: false, type: 'alert' });
  const [bulkRejectComment, setBulkRejectComment] = useState('');
  const [bulkErrors, setBulkErrors] = useState<WorkOrder[]>([]);
  const isDesktop = window.matchMedia('(min-width: 768px)');
  const [showModalOrderColumns, setShowModalOrderColumns] = useState(false);
  const [exportColumns, setExportColumns] = useState<string[]>(controlColumnsConfigs.filter((column) => !column.id.startsWith('LAST_PROG')).map((col) => col.id));
  const [columnsData, setColumnsData] = useState<(boolean | ColumnTable | undefined)[]>([]);
  const [state, render, setState] = useStateVar({
    isLoadingTable: false,
    sending: false,
    progress: 0,
    totalToSend: 0,
    isEditModal: false,
    pagination: {
      itemsPerPage: 10,
      totalItems: 0,
      currentPage: 1,
    },
    currentSort: {
      field: 'WORK_ORDER_HIST_UPDATED_AT',
      type: 'desc',
    },
    works: [] as WorkOrder[],
    isFirstReload: false,
    isLoading: true,
    periodSelected: t('dia'),
    typePeriodSelected: t('selecionar'),
    dateStart: null as null|moment.Moment,
    dateEnd: null as null|moment.Moment,
    focused: false,
    arrowDisabled: false,
    tomorrow: moment(moment().add(1, 'days').format('YYYY-MM-DD')),
    selected_ids_wo: [] as number[],
    selectedWorkOrders: [] as WorkOrder[],
    focusedInput: null as 'endDate'|'startDate'|null,
    selected_status_open: [] as number[],
    columnSort: {
      CLIENT_NAME: {
        column: 'CLIENT_NAME',
        desc: false,
      },
      UNIT_NAME: {
        column: 'UNIT_NAME',
        desc: false,
      },
      MACHINE_NAME: {
        column: 'MACHINE_NAME',
        desc: false,
      },
      ASSET_NAME: {
        column: 'ASSET_NAME',
        desc: false,
      },
      DEVICE_CODE: {
        column: 'DEVICE_CODE',
        desc: false,
      },
      HEALTH_INDEX: {
        column: 'HEALTH_INDEX',
        desc: false,
      },
      HEALTH_DESC: {
        column: 'HEALTH_DESC',
        desc: false,
      },
      WORK_ORDER_HIST_FAULT_INDEX: {
        column: 'WORK_ORDER_HIST_FAULT_INDEX',
        desc: false,
      },
      WORK_ORDER_HIST_FAULT_NAME: {
        column: 'WORK_ORDER_HIST_FAULT_NAME',
        desc: false,
      },
      DAT_REPORT: {
        column: 'DAT_REPORT',
        desc: false,
      },
      WORK_ORDER_HIST_STATE_ID: {
        column: 'WORK_ORDER_HIST_STATE_ID',
        desc: false,
      },
      WORK_ORDER_HIST_WO_CODE: {
        column: 'WORK_ORDER_HIST_WO_CODE',
        desc: false,
      },
      WORK_ORDER_HIST_CREATED_WO: {
        column: 'WORK_ORDER_HIST_CREATED_WO',
        desc: false,
      },
      WORK_ORDER_HIST_CLOSED_WO: {
        column: 'WORK_ORDER_HIST_CLOSED_WO',
        desc: false,
      },
      WORK_ORDER_HIST_UPDATED_AT: {
        column: 'WORK_ORDER_HIST_UPDATED_AT',
        desc: false,
      },
      ALERT_STATUS: {
        column: 'WORK_ORDER_HIST_STATE_ID',
        desc: false,
      },
      WORK_ORDER_MAINTENCE: {
        column: 'WORK_ORDER_HIST_STATE_ID',
        desc: false,
      },
    },
    filtersData: {} as any,
    selectedFilters: {
      clients: {
        label: t('cliente'),
        values: [],
      },
      units: {
        label: t('unidade'),
        values: [],
      },
      machines: {
        label: t('maquina'),
        values: [],
      },
      assets: {
        label: t('ativo'),
        values: [],
      },
      devices: {
        label: t('dispositivo'),
        values: [],
      },
      hIndex: {
        label: t('saudeAtual'),
        values: [],
      },
      hDesc: {
        label: t('falhas'),
        values: [],
      },
      workOrderHistFaultIndex: {
        label: t('saudeReportadaNaOS'),
        values: [],
      },
      workOrderHistFaultName: {
        label: t('falhaReportadaNaOS'),
        values: [],
      },
      woCode: {
        label: t('numeroDaOS'),
        values: [],
      },
      woState: {
        label: t('statusDaOS'),
        values: [],
      },
      alertState: {
        label: t('statusDoAlarme'),
        values: [],
      },
      woMaintenanceState: {
        label: t('statusDaManutencao'),
        values: [],
      },
    } as any,
    filterAll: {},
    dataModalSelected: {} as WorkOrder,
    commentsWorkOrder: {} as {
      ID: string;
      Comments: {
          ID: string;
          WORK_ORDER_ID: string;
          COMMENT_TEXT: string;
          COMMENTED_BY: string;
          STATE_ID: number;
          CREATED_AT: Date;
          UPDATED_AT: Date;
      }[];
    },
  });

  function handleSelection(label: string) {
    if (label === t('hoje') || label === t('ontem')) {
      state.periodSelected = t('dia');
    } else {
      state.periodSelected = t('flexivel');
    }

    render();
  }

  function handleChangePeriod(period: string) {
    state.periodSelected = period;
    if (period === t('dia')) {
      state.dateEnd = state.dateStart;
    }
    render();
  }

  function handleChangeTypePeriod(period: string) {
    state.typePeriodSelected = period;
    render();
  }

  function onDateChange(date: moment.Moment, dateEnd: moment.Moment, isQuickSelection?: boolean) {
    const dateEndAux = !isQuickSelection && date?.format('YYYY-MM-DD') !== state.dateStart?.format('YYYY-MM-DD') ? null : dateEnd;

    setState({
      dateStart: date,
      dateEnd: dateEndAux,
    });
  }

  const dateRanges = [
    {
      label: t('hoje'),
      start: () => moment(),
      end: () => moment(),
      changeSelectedPeriod: () => handleSelection(t('hoje')),
    },
    {
      label: t('ontem'),
      start: () => moment().subtract(1, 'day'),
      end: () => moment().subtract(1, 'day'),
      changeSelectedPeriod: () => handleSelection(t('ontem')),
    },
    {
      label: t('semanaAtual'),
      start: () => moment().startOf('week'),
      end: () => moment(),
      changeSelectedPeriod: () => handleSelection(t('semanaAtual')),
    },
    {
      label: t('semanaPassada'),
      start: () => moment().subtract(7, 'days').startOf('week'),
      end: () => moment().subtract(7, 'days').endOf('week'),
      changeSelectedPeriod: () => handleSelection(t('semanaPassada')),
    },
    {
      label: t('ultimos7dias'),
      start: () => moment().subtract(6, 'days'),
      end: () => moment(),
      changeSelectedPeriod: () => handleSelection(t('ultimos7dias')),
    },
    {
      label: t('ultimos15dias'),
      start: () => moment().subtract(14, 'days'),
      end: () => moment(),
      changeSelectedPeriod: () => handleSelection(t('ultimos15dias')),
    },
  ];

  function handleDateChangeDirection(change: number) {
    const dateInit = moment(state.dateStart);
    const dateEnd = moment(state.dateEnd);

    if (state.periodSelected === t('dia')) {
      const formattedDate = dateInit.add(change, 'days');
      setState({
        dateStart: formattedDate,
        dateEnd: formattedDate,
      });
    } else {
      const differenceInDays = dateEnd.diff(dateInit, 'days');
      const formattedDateInit = dateInit.add(change * differenceInDays, 'days');
      const formattedDateEnd = dateEnd.add(change * differenceInDays, 'days');
      setState({
        dateStart: formattedDateInit,
        dateEnd: formattedDateEnd,
      });
    }

    getDisabledButton();
  }

  function verifyRightArrowDisabled() {
    return state.arrowDisabled || (!state.dateStart || !state.dateEnd);
  }

  function getDisabledButton() {
    const endDate = moment(state.dateEnd);
    const currentDate = moment();
    const currentDay = currentDate.day();

    if (state.periodSelected === t('dia') && endDate.day() === currentDay) {
      setState({ arrowDisabled: true });
    } else {
      const differenceInDays = endDate.diff(moment(state.dateStart), 'days');
      const newEndDate = endDate.add(differenceInDays, 'days');

      setState({ arrowDisabled: currentDate.startOf('day').isBefore(newEndDate.startOf('day')) });
    }
  }

  function verifyIsOutsideRange(date: moment.Moment) {
    const startDate = moment(state.dateStart, 'YYYY-MM-DD').startOf('day');
    const maxEndDate = startDate.isValid() ? startDate.clone().add(14, 'day').endOf('day') : null;

    const isAfterMaxEndDate = maxEndDate ? date.isAfter(maxEndDate) : false;

    return isAfterMaxEndDate || !date.isBefore(state.tomorrow);
  }

  function veirifyLeftArrowDisabled() {
    return state.isLoading || (!state.dateStart || !state.dateEnd);
  }

  const filtersMappings = {
    [t('cliente')]: { filterKey: 'clients', filterAllKey: 'clients' },
    [t('unidade')]: { filterKey: 'units', filterAllKey: 'units' },
    [t('maquina')]: { filterKey: 'machines', filterAllKey: 'machines' },
    [t('ativo')]: { filterKey: 'assets', filterAllKey: 'assets' },
    [t('dispositivo')]: { filterKey: 'devices', filterAllKey: 'devices' },
    [t('saudeAtual')]: { filterKey: 'hIndex', filterAllKey: 'hIndex' },
    [t('falhas')]: { filterKey: 'hDesc', filterAllKey: 'hDesc' },
    [t('saudeReportadaNaOS')]: { filterKey: 'workOrderHistFaultIndex', filterAllKey: 'workOrderHistFaultIndex' },
    [t('falhaReportadaNaOS')]: { filterKey: 'workOrderHistFaultName', filterAllKey: 'workOrderHistFaultName' },
    [t('statusDaOS')]: { filterKey: 'woState', filterAllKey: 'woState' },
    [t('numeroDaOS')]: { filterKey: 'woCode', filterAllKey: 'woCode' },
    [t('statusDoAlarme')]: { filterKey: 'alertState', filterAllKey: 'alertState' },
    [t('statusDaManutencao')]: { filterKey: 'woMaintenanceState', filterAllKey: 'woMaintenanceState' },
  };

  const handleSelectAllFilters = async (name, filterAll) => {
    const mapping = filtersMappings[name];

    if (mapping) {
      state.selectedFilters[mapping.filterKey].values = filterAll ? state.filtersData[mapping.filterKey] : [];
      state.filterAll[mapping.filterAllKey] = filterAll;
    }

    await handleGetFilters();
    render();
  };

  const handleChangeFilters = async (name, filters) => {
    switch (name) {
      case t('cliente'):
        state.selectedFilters.clients.values = filters.map((filter) => state.filtersData.clients.find((filterData) => filterData.value === filter));
        break;
      case t('unidade'):
        state.selectedFilters.units.values = filters.map((filter) => state.filtersData.units.find((filterData) => filterData.value === filter));
        break;
      case t('maquina'):
        state.selectedFilters.machines.values = filters.map((filter) => state.filtersData.machines.find((filterData) => filterData.value === filter));
        break;
      case t('ativo'):
        state.selectedFilters.assets.values = filters.map((filter) => state.filtersData.assets.find((filterData) => filterData.value === filter));
        break;
      case t('dispositivo'):
        state.selectedFilters.devices.values = filters.map((filter) => state.filtersData.devices.find((filterData) => filterData.value === filter));
        break;
      case t('saudeAtual'):
        state.selectedFilters.hIndex.values = filters.map((filter) => state.filtersData.hIndex.find((filterData) => filterData.value === filter));
        break;
      case t('falhas'):
        state.selectedFilters.hDesc.values = filters.map((filter) => state.filtersData.hDesc.find((filterData) => filterData.value === filter));
        break;
      case t('saudeReportadaNaOS'):
        state.selectedFilters.workOrderHistFaultIndex.values = filters.map((filter) => state.filtersData.workOrderHistFaultIndex.find((filterData) => filterData.value === filter));
        break;
      case t('falhaReportadaNaOS'):
        state.selectedFilters.workOrderHistFaultName.values = filters.map((filter) => state.filtersData.workOrderHistFaultName.find((filterData) => filterData.value === filter));
        break;
      case t('statusDaOS'):
        state.selectedFilters.woState.values = filters.map((filter) => state.filtersData.woState.find((filterData) => filterData.value === filter));
        break;
      case t('numeroDaOS'):
        state.selectedFilters.woCode.values = filters.map((filter) => state.filtersData.woCode.find((filterData) => filterData.value === filter));
        break;
      case t('statusDoAlarme'):
        state.selectedFilters.alertState.values = filters.map((filter) => state.filtersData.alertState.find((filterData) => filterData.value === filter));
        break;
      case t('statusDaManutencao'):
        state.selectedFilters.woMaintenanceState.values = filters.map((filter) => state.filtersData.woMaintenanceState.find((filterData) => filterData.value === filter));
        break;
      default:
        break;
    }
    state.pagination.currentPage = 1;
    await handleGetFilters();
    render();
  };

  const handleGetFilters = async () => {
    setState({ isLoadingTable: true });
    try {
      const filterParams = setFiltersAndReturn(state);
      await getWOList(filterParams);
    } catch (e) {
      toast.error(t('naoFoiPossivelBuscarInformacoesFiltros'));
    }
    render();
    setState({ isLoadingTable: false });
  };

  function sortDataColumnKey(column) {
    Object.keys(state.columnSort).forEach((columnKey) => {
      if (columnKey === column) {
        state.columnSort[columnKey] = {
          column: state.columnSort[columnKey].column,
          desc: !state.columnSort[columnKey].desc,
        };
      } else {
        state.columnSort[columnKey] = {
          column: state.columnSort[columnKey].column,
          desc: false,
        };
      }
    });

    state.currentSort = {
      field: state.columnSort[column].column,
      type: state.columnSort[column].desc ? 'desc' : 'asc',
    };
  }

  const setFiltersAndReturn = (state) => {
    const filterParams = {
      clientIds: state.selectedFilters.clients.values?.map((filter) => filter.value),
      unitIds: state.selectedFilters.units.values?.map((filter) => filter.value),
      machineIds: state.selectedFilters.machines.values?.map((filter) => filter.value),
      assetIds: state.selectedFilters.assets.values?.map((filter) => filter.value),
      deviceCode: state.selectedFilters.devices.values?.map((filter) => filter.value),
      hIndex: state.selectedFilters.hIndex.values?.map((filter) => filter.value),
      hDesc: state.selectedFilters.hDesc.values?.map((filter) => filter.value),
      workOrderHistFaultIndex: state.selectedFilters.workOrderHistFaultIndex.values?.map((filter) => filter.value),
      workOrderHistFaultName: state.selectedFilters.workOrderHistFaultName.values?.map((filter) => filter.value),
      woCode: state.selectedFilters.woCode.values?.map((filter) => filter.value),
      woState: state.selectedFilters.woState.values?.map((filter) => filter.value),
      orderDirection: state.currentSort.type.toLowerCase(),
      orderBy: state.currentSort.field,
      typePeriod: convertTypePeriod(state.typePeriodSelected),
      dateStart: state.dateStart ? state.dateStart.startOf('day').toISOString() : null,
      dateEnd: state.dateEnd ? state.dateEnd.endOf('day').toISOString() : null,
    };

    filterParams.woState = [
      ...filterParams.woState,
      ...(state.selectedFilters.alertState.values ?? []).map((filter) => filter.value),
      ...(state.selectedFilters.woMaintenanceState.values ?? []).map((filter) => filter.value),
    ];

    if (filterParams.woState.includes(4)) {
      // Adiciona OSs com estado 9 tambem
      filterParams.woState.push(9);
      filterParams.woState.push(10);
    }

    return filterParams;
  };

  const convertTypePeriod = (typePeriod) => {
    switch (typePeriod) {
      case t('aberturaDaOS'):
        return 'WORK_ORDER_HIST_CREATED_WO';
      case t('ultimaAtualizacaoDaOS'):
        return 'WORK_ORDER_HIST_UPDATED_AT';
      case t('fechamentoDaOS'):
        return 'WORK_ORDER_HIST_CLOSED_WO';
      default:
        return '';
    }
  };

  const handleSortData = async (column) => {
    setState({ isLoadingTable: true });
    sortDataColumnKey(column);
    const filterParams = setFiltersAndReturn(state);
    await getWOList(filterParams);
    render();
    setState({ isLoadingTable: false });
  };

  const getWOList = async (filterParams) => {
    try {
      const sortParams = {} as {orderByField: string, orderByType: string };
      const filterParamsSet = filterParams;
      if (state.currentSort.field && state.currentSort.type) {
        sortParams.orderByField = state.currentSort.field;
        sortParams.orderByType = state.currentSort.type;
      }
      const { works, totalItems } = await apiCall('/mainservice/work-order/get-work-orders', { limit: state.pagination.itemsPerPage, page: state.pagination.currentPage, ...filterParamsSet });
      setState({
        works,
      });
      state.pagination.totalItems = totalItems;
      render();
    } catch (error) {
      toast.error(t('houveErroBuscandoAsAnalises'));
      render();
    }
  };

  const columnsTable = [
    {
      accessor: 'COL_SELECTION',
      disableSortBy: true,
      Header: () => (
        <Checkbox
          checked={state.works.length > 0 && state.selectedWorkOrders.length === state.works.length}
          onClick={(e) => { e.stopPropagation(); toggleSelectAll(state.selectedWorkOrders.length !== state.works.length); }}
        />
      ),
      Cell: (props) => {
        const wo = props.row.original as WorkOrder;
        return (
          <Checkbox
            checked={!!state.selectedWorkOrders.find((s) => s.WORK_ORDER_HIST_ID === wo.WORK_ORDER_HIST_ID)}
            onClick={(e) => { e.stopPropagation(); toggleSelectWorkOrder(wo); }}
          />
        );
      },
    },
    {
      accessor: 'COMMENTS',
      disableSortBy: false,
      Cell: (props) => {
        const id = props.row.original.WORK_ORDER_HIST_ID;
        return (
          <button type="button" onClick={() => handleModalOpen(id, false)} style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}>
            <OlhoAberto />
          </button>
        );
      },
    },
    {
      Header: () => (
        GenerateItemColumn(t('cliente'), 'CLIENT_NAME', handleSortData, state.columnSort.CLIENT_NAME, {
          hasFilter: true,
          options: state.filtersData.clients,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.clients?.length === state.selectedFilters.clients.values.length,
          value: state.selectedFilters.clients.values,
        })
      ),
      accessor: 'CLIENT_NAME',
      disableSortBy: true,
      Cell: (props) => StringLabel(props.row.original.CLIENT_NAME, 'CLIENT_NAME'),
    },
    {
      Header: () => (
        GenerateItemColumn(t('unidade'), 'UNIT_NAME', handleSortData, state.columnSort.UNIT_NAME, {
          hasFilter: true,
          options: state.filtersData.units,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.units?.length === state.selectedFilters.units.values.length,
          value: state.selectedFilters.units.values,
        })
      ),
      accessor: 'UNIT_NAME',
      disableSortBy: true,
      Cell: (props) => StringLabel(props.row.original.UNIT_NAME, 'UNIT_NAME'),
    },
    {
      Header: () => (
        GenerateItemColumn(t('maquina'), 'MACHINE_NAME', handleSortData, state.columnSort.MACHINE_NAME, {
          hasFilter: true,
          options: state.filtersData.machines,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.machines?.length === state.selectedFilters.machines.values.length,
          value: state.selectedFilters.machines.values,
        })
      ),
      accessor: 'MACHINE_NAME',
      disableSortBy: true,
      Cell: (props) => StringLabel(props.row.original.MACHINE_NAME, 'MACHINE_NAME'),
    },
    {
      Header: () => (
        GenerateItemColumn(t('ativo'), 'ASSET_NAME', handleSortData, state.columnSort.ASSET_NAME, {
          hasFilter: true,
          options: state.filtersData.assets,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.assets?.length === state.selectedFilters.assets.values.length,
          value: state.selectedFilters.assets.values,
        })
      ),
      accessor: 'ASSET_NAME',
      disableSortBy: true,
      Cell: (props) => StringLabel(props.row.original.ASSET_NAME, 'ASSET_NAME'),
    },
    {
      Header: () => (
        GenerateItemColumn(t('dispositivo'), 'DEVICE_CODE', handleSortData, state.columnSort.DEVICE_CODE, {
          hasFilter: true,
          options: state.filtersData.devices,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.devices?.length === state.selectedFilters.devices.values.length,
          value: state.selectedFilters.devices.values,
        })
      ),
      accessor: 'DEVICE_CODE',
      disableSortBy: true,
      Cell: (props) => {
        const { DEVICE_CODE, DAT_REPORT } = props.row.original;
        const dateParam = DAT_REPORT ? `?data=${encodeURIComponent(moment(DAT_REPORT).format('DD/MM/YYYY'))}` : '';
        return <StyledLink target="_blank" rel="noopener noreferrer" to={`/analise/dispositivo/${DEVICE_CODE}/historico${dateParam}`}>{DEVICE_CODE}</StyledLink>;
      },
    },
    {
      Header: () => (
        GenerateItemColumn(t('saudeAtual'), 'HEALTH_INDEX', handleSortData, state.columnSort.HEALTH_INDEX, {
          hasFilter: true,
          options: state.filtersData.hIndex,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.hIndex?.length === state.selectedFilters.hIndex.values.length,
          value: state.selectedFilters.hIndex.values,
        })
      ),
      accessor: 'HEALTH_INDEX',
      disableSortBy: true,
      Cell: (props) => HealthCell(props.row.original.HEALTH_INDEX),
    },
    {
      Header: () => (
        GenerateItemColumn(t('falhas'), 'HEALTH_DESC', handleSortData, state.columnSort.HEALTH_DESC, {
          hasFilter: true,
          options: state.filtersData.hDesc,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.hDesc?.length === state.selectedFilters.hDesc.values.length,
          value: state.selectedFilters.hDesc.values,
        })
      ),
      accessor: 'HEALTH_DESC',
      disableSortBy: true,
      Cell: (props) => StringLabel(props.row.original.HEALTH_DESC, 'HEALTH_DESC'),
    },
    {
      Header: () => (
        GenerateItemColumn(t('saudeReportadaNaOS'), 'WORK_ORDER_HIST_FAULT_INDEX', handleSortData, state.columnSort.WORK_ORDER_HIST_FAULT_INDEX, {
          hasFilter: true,
          options: state.filtersData.workOrderHistFaultIndex,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.workOrderHistFaultIndex?.length === state.selectedFilters.workOrderHistFaultIndex.values.length,
          value: state.selectedFilters.workOrderHistFaultIndex.values,
        })
      ),
      accessor: 'WORK_ORDER_HIST_FAULT_INDEX',
      disableSortBy: true,
      Cell: (props) => HealthCell(props.row.original.WORK_ORDER_HIST_FAULT_INDEX),
    },
    {
      Header: () => (
        GenerateItemColumn(t('falhaReportadaNaOS'), 'WORK_ORDER_HIST_FAULT_NAME', handleSortData, state.columnSort.WORK_ORDER_HIST_FAULT_NAME, {
          hasFilter: true,
          options: state.filtersData.workOrderHistFaultName,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.workOrderHistFaultName?.length === state.selectedFilters.workOrderHistFaultName.values.length,
          value: state.selectedFilters.workOrderHistFaultName.values,
        })
      ),
      accessor: 'WORK_ORDER_HIST_FAULT_NAME',
      disableSortBy: true,
      Cell: (props) => StringLabel(props.row.original.WORK_ORDER_HIST_FAULT_NAME, 'WORK_ORDER_HIST_FAULT_NAME'),
    },
    {
      Header: () => (
        GenerateItemColumn(t('ultimaDeteccao'), 'DAT_REPORT', handleSortData, state.columnSort.DAT_REPORT)
      ),
      accessor: 'DAT_REPORT',
      disableSortBy: true,
      Cell: (props) => DateLabel(props.row.original.DAT_REPORT, 'DAT_REPORT'),
    },
    {
      Header: () => (
        GenerateItemColumn(t('statusDaOS'), 'WORK_ORDER_HIST_STATE_ID', handleSortData, state.columnSort.WORK_ORDER_HIST_STATE_ID, {
          hasFilter: true,
          options: state.filtersData.woState,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.woState?.length === state.selectedFilters.woState.values.length,
          value: state.selectedFilters.woState.values,
        })
      ),
      accessor: 'WORK_ORDER_HIST_STATE_ID',
      disableSortBy: true,
      Cell: (props) => StatusCell(props.row.original.WORK_ORDER_HIST_STATE_ID),
    },
    {
      Header: () => (
        GenerateItemColumn(t('aberturaDaOS'), 'WORK_ORDER_HIST_CREATED_WO', handleSortData, state.columnSort.WORK_ORDER_HIST_CREATED_WO)
      ),
      accessor: 'WORK_ORDER_HIST_CREATED_WO',
      disableSortBy: true,
      Cell: (props) => <WorkOrderCreatedCell value={props.row.original.WORK_ORDER_HIST_CREATED_WO?.value} />,
    },
    {
      Header: () => (
        GenerateItemColumn(t('ultimaAtualizacaoDaOS'), 'WORK_ORDER_HIST_UPDATED_AT', handleSortData, state.columnSort.WORK_ORDER_HIST_UPDATED_AT)
      ),
      accessor: 'WORK_ORDER_HIST_UPDATED_AT',
      disableSortBy: true,
      Cell: (props) => <WorkOrderUpdatedCell value={props.row.original.WORK_ORDER_HIST_UPDATED_AT?.value} />,
    },
    {
      Header: () => (
        GenerateItemColumn(t('fechamentoDaOS'), 'WORK_ORDER_HIST_CLOSED_WO', handleSortData, state.columnSort.WORK_ORDER_HIST_CLOSED_WO)
      ),
      accessor: 'WORK_ORDER_HIST_CLOSED_WO',
      disableSortBy: true,
      Cell: (props) => <WorkOrderClosedCell value={props.row.original.WORK_ORDER_HIST_CLOSED_WO?.value} />,
    },
    {
      Header: () => (
        GenerateItemColumn(t('numeroDaOS'), 'WORK_ORDER_HIST_WO_CODE', handleSortData, state.columnSort.WORK_ORDER_HIST_WO_CODE, {
          hasFilter: true,
          options: state.filtersData.woCode,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.woCode?.length === state.selectedFilters.woCode.values.length,
          value: state.selectedFilters.woCode.values,
        })
      ),
      accessor: 'WORK_ORDER_HIST_WO_CODE',
      disableSortBy: true,
      Cell: (props) => (props.row.original.WORK_ORDER_HIST_WO_CODE ? StringLabel(props.row.original.WORK_ORDER_HIST_WO_CODE, 'WORK_ORDER_HIST_WO_CODE') : <div />),
    },
    {
      Header: () => (
        GenerateItemColumn(t('statusDoAlarme'), 'ALERT_STATUS', handleSortData, state.columnSort.ALERT_STATUS, {
          hasFilter: true,
          options: state.filtersData.alertState,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.alertState?.length === state.selectedFilters.alertState.values.length,
          value: state.selectedFilters.alertState.values,
        })
      ),
      accessor: 'ALERT_STATUS',
      disableSortBy: true,
      Cell: (props) => {
        const id = props.row.original.WORK_ORDER_HIST_ID;
        const dat = props.row.original.DAT_REPORT;
        const status = props.row.original.WORK_ORDER_HIST_STATE_ID;
        const data = props.row.original;
        return (
          <OptionsButtonStatusAlert
            key={id}
            id={id}
            dat={dat}
            handleButtonStatusToggle={handleButtonStatusToggle}
            isOpen={state.selected_status_open.includes(dat)}
            status={status}
            data={data}
            onActivateClick={(id, action, data) => handleSendAlertStatus(id, action, data)}
          />
        );
      },
    },
    {
      Header: () => (
        GenerateItemColumn(t('statusDaManutencao'), 'WORK_ORDER_MAINTENCE', handleSortData, state.columnSort.WORK_ORDER_MAINTENCE, {
          hasFilter: true,
          options: state.filtersData.woMaintenanceState,
          onChangeFilter: handleChangeFilters,
          onSelectAllOptions: handleSelectAllFilters,
          filterAll: state.filtersData.woMaintenanceState?.length === state.selectedFilters.woMaintenanceState.values.length,
          value: state.selectedFilters.woMaintenanceState.values,
        })
      ),
      accessor: 'WORK_ORDER_MAINTENCE',
      disableSortBy: true,
      Cell: (props) => {
        const id = props.row.original.WORK_ORDER_HIST_ID;
        const status = props.row.original.WORK_ORDER_HIST_STATE_ID;
        return (
          <OptionsButtonStatusWO
            key={id}
            id={id}
            handleButtonStatusToggle={handleButtonStatusToggle}
            isOpen={state.selected_status_open.includes(id)}
            status={status}
            onActivateClick={(id, action) => {
              handleModalOpen(id, true, action);
            }}
          />
        );
      },
    },
  ];

  const handleModalOpen = async (selected_id: string, is_edit: boolean, action?: number) => {
    setState({ isEditModal: is_edit });
    if (action === 6) {
      state.dataModalSelected = state.works.find((work) => work.WORK_ORDER_HIST_ID === selected_id) ?? {} as WorkOrder;
      state.commentsWorkOrder = await apiCall('/mainservice/work-order/get-work-order-by-id', { workOrderId: selected_id });
      setIsModalOpen(true);
    }
    if (action === 5) {
      await apiCall('/mainservice/work-order/work-order-ratification', {
        workOrderId: selected_id,
        type: 'CONFIRM_MAINTENANCE',
        action: 'APPROVED',
      });
      await handleGetFilters();
    }
    if (!action) {
      state.dataModalSelected = state.works.find((work) => work.WORK_ORDER_HIST_ID === selected_id) ?? {} as WorkOrder;
      state.commentsWorkOrder = await apiCall('/mainservice/work-order/get-work-order-by-id', { workOrderId: selected_id });
      setIsModalOpen(true);
    }
    render();
  };

  const handleButtonStatusToggle = (id) => {
    const isAlreadySelected = state.selected_status_open.includes(id);
    const updatedSelectedIds = isAlreadySelected
      ? []
      : [id];
    setState({
      selected_status_open: updatedSelectedIds,
    });
  };

  function handleSetExportColumns(columns) {
    const columnsToExport: string[] = [];
    for (const col of columns) {
      if (col?.visible) {
        columnsToExport.push(col.id);
      }
    }
    setExportColumns(columnsToExport);
  }

  const handleChangeColumns = (columnId) => {
    const toggleVisibility = (column) => ({
      ...column,
      visible: column.id === columnId ? !column.visible : column.visible,
    });

    const updatedColumns = controlColumns.map(toggleVisibility);
    setControlColumns(updatedColumns);
    handleSetExportColumns(updatedColumns);

    const newColumnsData = updatedColumns.map((column) => {
      if (column.visible === true) {
        return columnsTable.find((columnTable) => columnTable && columnTable.accessor === column.id) ?? false;
      }
      return false;
    });

    setColumnsData(newColumnsData);

    return updatedColumns.some((column) => column.visible);
  };

  const filterColumns = (columns, controlColumnsFilter) => {
    const newColumnsData = controlColumnsFilter.map((column) => {
      if (column.visible === true) {
        return columns.find((columnTable) => columnTable && columnTable.accessor === column.id) ?? false;
      }
      return false;
    });
    return newColumnsData;
  };

  const handleSetColumnsData = (columns) => {
    setControlColumns(columns);
    handleSetExportColumns(columns);

    const newColumnsData = columns.map((column) => {
      if (column.visible === true) {
        return columnsTable.find((columnTable) => {
          if (columnTable && typeof columnTable !== 'boolean') {
            return columnTable.accessor === column.id;
          }

          return false;
        }) ?? false;
      }
      return false;
    });

    setColumnsData(newColumnsData);
  };

  useEffect(() => {
    if (state.typePeriodSelected !== t('selecionar') && state.dateStart) {
      handleGetFilters();
    }
  }, [state.dateStart, state.dateEnd, state.typePeriodSelected]);

  useEffect(() => {
    setColumnsData(filterColumns(columnsTable, controlColumns));
  }, []);

  useEffect(() => {
    setControlColumns(controlColumnsConfigs);
    setExportColumns(controlColumnsConfigs.map((col) => col.id));
    setColumnsData(filterColumns(columnsTable, controlColumnsConfigs));
    fetchData();
  }, []);

  async function fetchData() {
    const hIndex = [
      { value: '100', name: t('operandoCorretamente') },
      { value: '75', name: t('foraDeEspecificacao') },
      { value: '50', name: t('riscoIminente') },
      { value: '25', name: t('manutencaoUrgente') },
      { value: '2', name: t('equipamentoOffline') },
      { value: '4', name: t('maquinaDesativada') },
    ];
    const faultsName = [
      { value: 'Baixa troca de calor na evaporadora com risco de congelamento', name: 'Baixa troca de calor na evaporadora com risco de congelamento' },
      { value: 'Alta temperatura no ambiente de condensação', name: 'Alta temperatura no ambiente de condensação' },
      { value: 'Baixa capacidade de refrigeração', name: 'Baixa capacidade de refrigeração' },
      { value: 'Baixa troca de calor na condensadora', name: 'Baixa troca de calor na condensadora' },
      { value: 'Baixa troca de calor na evaporadora', name: 'Baixa troca de calor na evaporadora' },
      { value: 'Baixo uso de máquina', name: 'Baixo uso de máquina' },
      { value: 'Compressor Inoperante', name: 'Compressor Inoperante' },
      { value: 'Compressor Inoperante (L1 Virtual)', name: 'Compressor Inoperante (L1 Virtual)' },
      { value: 'Deficiência de fornecimento de água gelada', name: 'Deficiência de fornecimento de água gelada' },
      { value: 'Falha elétrica', name: 'Falha elétrica' },
      { value: 'Sistema operando com alto número de partidas', name: 'Sistema operando com alto número de partidas' },
      { value: 'Risco de entrada de líquido no compressor', name: 'Risco de entrada de líquido no compressor' },
      { value: 'Sistema sem fluido refrigerante', name: 'Sistema sem fluido refrigerante' },
      { value: 'Superaquecimento elevado', name: 'Superaquecimento elevado' },
      { value: 'Temperatura de saída alta', name: 'Temperatura de saída alta' },
      { value: 'Risco de obstrução por gelo', name: 'Risco de obstrução por gelo' },
      { value: 'Máquina inoperante', name: 'Máquina inoperante' },
      { value: 'Compressor ineficiente', name: 'Compressor ineficiente' },
      { value: 'Automação em bypass', name: 'Automação em bypass' },
    ];

    try {
      const [filters, { works, totalItems }] = await Promise.all([
        apiCall('/mainservice/work-order/get-work-order-combo-opts'),
        apiCall('/mainservice/work-order/get-work-orders'),
      ]);
      setState({
        works,
        isLoading: false,
        filtersData: {
          ...filters,
          hIndex,
          workOrderHistFaultIndex: hIndex,
          woState: [
            { value: 3, name: t('osAberta') },
            { value: 7, name: t('osConcluida') },
            { value: 8, name: t('osCancelada') },
            { value: 9, name: t('osFechadaPeloCliente') },
            { value: 10, name: t('osFechadaApenasParaDiel') },
          ],
          alertState: [
            { value: 1, name: t('aguardandoAprovacao') },
            { value: 2, name: t('aprovado') },
          ],
          woMaintenanceState: [
            { value: 4, name: t('manutencaoPendente') },
            { value: 5, name: t('manutencaoAprovada') },
            { value: 6, name: t('manutencaoRejeitada') },
          ],
          hDesc: faultsName,
          workOrderHistFaultName: faultsName,
        },
      });
      state.pagination.totalItems = totalItems;
    } catch (error) {
      toast.error(t('erroBuscarInformacoes'));
      state.isLoading = false;
    }
    render();
  }

  const handleModalClose = () => {
    setIsModalOpen(false);
    render();
  };

  function getUserName() {
    return `${profile.name} ${profile.lastName}`;
  }

  async function handleSendComment(data: WorkOrder) {
    if (!textComment) {
      toast.error(t('paraReprovarDevePreencherOComentario'));
      return;
    }
    await apiCall('/mainservice/work-order/work-order-ratification', {
      workOrderId: state.dataModalSelected.WORK_ORDER_HIST_ID,
      comment: textComment,
      type: 'CONFIRM_MAINTENANCE',
      action: 'REJECTED',
      userName: getUserName(),
      sendWorkOrderNotification: {
        clientId: data.CLIENT_ID,
        clientName: data.CLIENT_NAME,
        unitIdApi: data.UNIT_ID_API,
        unitName: data.UNIT_NAME,
        machineName: data.MACHINE_NAME,
        assetName: data.ASSET_NAME,
        deviceCode: data.DEVICE_CODE,
        faultIndex: data.WORK_ORDER_HIST_FAULT_INDEX,
        faultName: data.WORK_ORDER_HIST_FAULT_NAME,
      },
    });
    await handleGetFilters();
    handleModalClose();
    render();
  }

  async function handleSendAlertStatus(id: string, action: 'REJECTED' | 'APPROVED', data: WorkOrder) {
    try {
      await apiCall('/mainservice/work-order/work-order-ratification', {
        workOrderId: id,
        type: 'CREATE_WORK_ORDER',
        action,
        sendWorkOrderNotification: {
          clientId: data.CLIENT_ID,
          clientName: data.CLIENT_NAME,
          unitIdApi: data.UNIT_ID_API,
          unitName: data.UNIT_NAME,
          machineName: data.MACHINE_NAME,
          assetName: data.ASSET_NAME,
          deviceCode: data.DEVICE_CODE,
          faultIndex: data.WORK_ORDER_HIST_FAULT_INDEX,
          faultName: data.WORK_ORDER_HIST_FAULT_NAME,
        },
      });
    } finally {
      await handleGetFilters();
      handleModalClose();
      render();
    }
  }

  function toggleSelectWorkOrder(wo: WorkOrder) {
    const already = state.selectedWorkOrders.find((s) => s.WORK_ORDER_HIST_ID === wo.WORK_ORDER_HIST_ID);
    state.selectedWorkOrders = already
      ? state.selectedWorkOrders.filter((s) => s.WORK_ORDER_HIST_ID !== wo.WORK_ORDER_HIST_ID)
      : [...state.selectedWorkOrders, wo];
    render();
  }

  function toggleSelectAll(checked: boolean) {
    state.selectedWorkOrders = checked ? [...state.works] : [];
    render();
  }

  async function runBulkWithTracking(
    eligible: WorkOrder[],
    makeRequest: (wo: WorkOrder) => Promise<unknown>,
  ): Promise<WorkOrder[]> {
    const BATCH_SIZE = 8;
    const failed: WorkOrder[] = [];
    const chunks: WorkOrder[][] = [];
    for (let i = 0; i < eligible.length; i += BATCH_SIZE) {
      chunks.push(eligible.slice(i, i + BATCH_SIZE));
    }
    for (const chunk of chunks) {
      const results = await Promise.allSettled(chunk.map((wo) => makeRequest(wo)));
      results.forEach((result, idx) => {
        if (result.status === 'rejected') failed.push(chunk[idx]);
      });
      await new Promise((resolve) => setTimeout(resolve, 100));
      setState({ progress: state.progress + chunk.length });
    }
    return failed;
  }

  async function handleBulkAlertStatus(action: 'APPROVED' | 'REJECTED', comment?: string) {
    const eligible = state.selectedWorkOrders.filter((wo) => wo.WORK_ORDER_HIST_STATE_ID === 1);
    if (!eligible.length) {
      toast.warn(t('nenhumItemElegivel'));
      return;
    }
    setState({ sending: true, progress: 0, totalToSend: eligible.length });
    const failed = await runBulkWithTracking(eligible, (wo) => apiCall('/mainservice/work-order/work-order-ratification', {
      workOrderId: wo.WORK_ORDER_HIST_ID,
      type: 'CREATE_WORK_ORDER',
      action,
      ...(comment ? { comment } : {}),
      sendWorkOrderNotification: {
        clientId: wo.CLIENT_ID,
        clientName: wo.CLIENT_NAME,
        unitIdApi: wo.UNIT_ID_API,
        unitName: wo.UNIT_NAME,
        machineName: wo.MACHINE_NAME,
        assetName: wo.ASSET_NAME,
        deviceCode: wo.DEVICE_CODE,
        faultIndex: wo.WORK_ORDER_HIST_FAULT_INDEX,
        faultName: wo.WORK_ORDER_HIST_FAULT_NAME,
      },
    }));
    setState({ sending: false });
    if (failed.length) setBulkErrors(failed);
    state.selectedWorkOrders = [];
    await handleGetFilters();
  }

  async function handleBulkMaintenanceStatus(action: 'APPROVED' | 'REJECTED', comment?: string) {
    const eligible = state.selectedWorkOrders.filter((wo) => wo.WORK_ORDER_HIST_STATE_ID === 4 || wo.WORK_ORDER_HIST_STATE_ID === 9);
    if (!eligible.length) {
      toast.warn(t('nenhumItemElegivel'));
      return;
    }
    setState({ sending: true, progress: 0, totalToSend: eligible.length });
    const failed = await runBulkWithTracking(eligible, (wo) => apiCall('/mainservice/work-order/work-order-ratification', {
      workOrderId: wo.WORK_ORDER_HIST_ID,
      type: 'CONFIRM_MAINTENANCE',
      action,
      ...(comment ? { comment } : {}),
    }));
    setState({ sending: false });
    if (failed.length) setBulkErrors(failed);
    state.selectedWorkOrders = [];
    await handleGetFilters();
  }

  function openBulkRejectModal(type: 'alert' | 'maintenance') {
    const eligible = type === 'alert'
      ? state.selectedWorkOrders.filter((wo) => wo.WORK_ORDER_HIST_STATE_ID === 1)
      : state.selectedWorkOrders.filter((wo) => wo.WORK_ORDER_HIST_STATE_ID === 4 || wo.WORK_ORDER_HIST_STATE_ID === 9);
    if (!eligible.length) {
      toast.warn(t('nenhumItemElegivel'));
      return;
    }
    setBulkRejectComment('');
    setBulkRejectModal({ open: true, type });
  }

  async function confirmBulkReject() {
    const { type } = bulkRejectModal;
    setBulkRejectModal({ open: false, type });
    if (type === 'alert') {
      await handleBulkAlertStatus('REJECTED', bulkRejectComment || undefined);
    } else {
      await handleBulkMaintenanceStatus('REJECTED', bulkRejectComment || undefined);
    }
    setBulkRejectComment('');
  }

  async function handleChangePagination(current) {
    state.pagination.currentPage = current;
    const filterParams = setFiltersAndReturn(state);
    await getWOList(filterParams);
    render();
  }

  async function clearDate() {
    state.dateStart = null;
    state.dateEnd = null;
    state.isLoading = true;
    render();
    await fetchData();
  }

  return (
    <Container>
      <Helmet>
        <title>Diel Energia - Falhas API</title>
      </Helmet>
      <AdminLayout />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '23px' }}>
        <FaultsLayout />
      </div>
      {state.isLoading ? (
        <LoaderContainer>
          <Loader variant="primary" />
          <span>Carregando</span>
        </LoaderContainer>
      ) : (
        <>
          <br />
          <Flex flexWrap="wrap" style={{ gap: '10px', justifyContent: 'space-between' }} mb={20}>
            <Flex style={{ gap: '10px' }}>
              <Box minWidth="110px">
                <Select
                  options={[
                    t('dia'),
                    t('flexivel'),
                  ]}
                  onSelect={(period: string) => {
                    handleChangePeriod(period);
                  }}
                  value={state.periodSelected}
                  placeholder={t('periodo')}
                  hideSelected
                  small
                // @ts-ignore
                  disabled={state.isLoading}
                  removeScroll
                />
                <div style={{ marginTop: 3 }} />
                <QuickSelectionV2
                  height="auto"
                  twoColumns
                  dateRanges={dateRanges}
                  setDate={(startDate, endDate) => {
                    onDateChange(startDate, endDate, true);
                  }}
                />
              </Box>
              <Box alignItems="center">
                <ContentDate style={{ minHeight: '40px', width: '270px' }}>
                  <Flex justifyContent="space-between">
                    <ContainerArrowLeft disabled={veirifyLeftArrowDisabled()} onClick={() => handleDateChangeDirection(-1)}>
                      <ArrowLeftIcon color={veirifyLeftArrowDisabled() ? '#E6E6E6' : colors.brand.primary.dark} />
                    </ContainerArrowLeft>
                    <Flex flexDirection="column" width="100%">
                      <LabelData>{t('data')}</LabelData>
                      {state.periodSelected === t('dia') && (
                      <SingleDatePicker
                        disabled={state.isLoading}
                        date={state.dateStart}
                        onDateChange={(data) => { setState({ dateStart: data, dateEnd: data }); getDisabledButton(); }}
                        focused={state.focused}
                        onFocusChange={({ focused }) => {
                          state.focused = focused;
                          render();
                        }}
                        id="datepicker"
                        numberOfMonths={1}
                        displayFormat="DD/MM/YYYY"
                        isOutsideRange={(d) => !d.isBefore(state.tomorrow)}
                        placeholder={t('selecioneUmaData')}
                      />
                      )}
                      {state.periodSelected === t('flexivel') && (
                      <DateRangePicker
                        small
                        readOnly
                        disabled={state.isLoading}
                        startDate={state.dateStart}
                        startDateId="your_unique_start_date_id"
                        endDate={state.dateEnd}
                        endDateId="your_unique_end_date_id"
                        onDatesChange={({ startDate, endDate }) => {
                          onDateChange(startDate, endDate);
                          getDisabledButton();
                        }}
                        onFocusChange={(focused) => {
                          state.focusedInput = focused;
                          render();
                        }}
                        focusedInput={state.focusedInput}
                        noBorder
                        isOutsideRange={verifyIsOutsideRange}
                        startDatePlaceholderText={t('dataInicial')}
                        endDatePlaceholderText={t('dataFinal')}
                      />
                      )}
                    </Flex>
                    <ContainerArrowRight disabled={verifyRightArrowDisabled()} onClick={() => handleDateChangeDirection(1)}>
                      <ArrowRightIcon color={verifyRightArrowDisabled() ? '#E6E6E6' : colors.brand.primary.dark} />
                    </ContainerArrowRight>
                  </Flex>
                </ContentDate>
                <ClearBtn onClick={() => clearDate()}>{t('limpar')}</ClearBtn>
              </Box>
              <Box minWidth="150px">
                <Select
                  options={[
                    t('aberturaDaOS'),
                    t('ultimaAtualizacaoDaOS'),
                    t('fechamentoDaOS'),
                  ]}
                  onSelect={(period: string) => {
                    handleChangeTypePeriod(period);
                  }}
                  value={state.typePeriodSelected}
                  placeholder={t('tipoDeData')}
                  hideSelected
                  small
                  disabled={state.isLoading}
                  removeScroll
                />
              </Box>
            </Flex>
            <Flex style={{ gap: '10px' }}>
              <ButtonOptions
                onClick={() => setShowModalOrderColumns(!showModalOrderColumns)}
                disabled={state.isLoading}
              >
                <ColumnIcon />
                <p style={{ margin: '0%' }}>{t('colunas')}</p>
              </ButtonOptions>
              <ButtonOptions
                onClick={() => {}}
                disabled
              >
                <ExportIcon />
                <p style={{ margin: '0%' }}>{t('botaoExportar')}</p>
              </ButtonOptions>
            </Flex>
          </Flex>
          {state.selectedWorkOrders.length > 0 && (
            <BulkActionBar>
              <span style={{ fontSize: 13, fontWeight: 600 }}>
                {`${state.selectedWorkOrders.length} ${t('selecionado(s)')}`}
              </span>
              <span style={{ fontSize: 12, fontWeight: 600, marginLeft: 8 }}>
                {t('statusDoAlarme')}
                :
              </span>
              <ButtonOptions style={{ borderRadius: 4 }} onClick={() => handleBulkAlertStatus('APPROVED')}>
                <Approved size={14} />
                <p style={{ margin: 0 }}>Aprovar</p>
              </ButtonOptions>
              <ButtonOptions style={{ borderRadius: 4 }} onClick={() => openBulkRejectModal('alert')}>
                <Reproved size={14} />
                <p style={{ margin: 0 }}>Reprovar</p>
              </ButtonOptions>
              <span style={{ fontSize: 12, fontWeight: 600, marginLeft: 8 }}>
                {t('statusDaManutencao')}
                :
              </span>
              <ButtonOptions style={{ borderRadius: 4 }} onClick={() => handleBulkMaintenanceStatus('APPROVED')}>
                <Approved size={14} />
                <p style={{ margin: 0 }}>Aprovar</p>
              </ButtonOptions>
              <ButtonOptions style={{ borderRadius: 4 }} onClick={() => openBulkRejectModal('maintenance')}>
                <Reproved size={14} />
                <p style={{ margin: 0 }}>Reprovar</p>
              </ButtonOptions>
            </BulkActionBar>
          )}
          <Card noPaddingRelative>
            <>
              {controlColumns.some(
                (column) => column.visible === true,
              ) ? (
                <TableWrapper>
                  <Table
                    style={{ minHeight: '70vh' }}
                    columns={columnsData.filter(Boolean)}
                    data={state.works}
                    noDataComponent={NoDataInTable}
                    noBorderBottom
                  />
                </TableWrapper>

                ) : <NoDataInTable />}
              {showModalOrderColumns && (
              <ModalOrderColumns
                handleCancelModal={() => {
                  setShowModalOrderColumns(false);
                }}
                handleSubmitModal={() => setShowModalOrderColumns(false)}
                columns={controlColumns}
                handleChangeColumns={handleChangeColumns}
                isDesktop={isDesktop.matches}
                handleDragColumn={(dragIndex, hoverIndex) => {
                  setControlColumns((prevState) => {
                    const dataAux = reorderList(prevState, dragIndex, hoverIndex);
                    handleSetExportColumns(dataAux);
                    return dataAux;
                  });
                  setColumnsData((prevState) => reorderList(prevState, dragIndex, hoverIndex));
                }}
                handleResetColumns={(originalColumns) => {
                  handleSetColumnsData(originalColumns);
                }}
              />
              )}
            </>
            <Flex justifyContent="flex-end" width={1} mt={10} mb={10}>
              <Pagination
                className="ant-pagination"
                current={state.pagination.currentPage}
                total={state.pagination.totalItems}
                pageSize={state.pagination.itemsPerPage}
                onChange={(current) => handleChangePagination(current)}
              />
            </Flex>
          </Card>
        </>
      )}
      {state.isLoadingTable && (
        <LoaderOverlay>
          <Loader variant="primary" size="large" />
        </LoaderOverlay>
      )}
      {state.sending && (
        <ProgressOverlay>
          <ProgressModal>
            <strong style={{ fontSize: '16px' }}>{t('processandoConfirmacoes')}</strong>
            <span style={{ color: '#666', fontSize: '14px' }}>
              {`${Math.min(state.progress, state.totalToSend)} de ${state.totalToSend} enviada(s)`}
            </span>
            <ProgressBarTrack>
              <ProgressBarFill
                $pct={state.totalToSend > 0
                  ? (Math.min(state.progress, state.totalToSend) / state.totalToSend) * 100
                  : 0}
              />
            </ProgressBarTrack>
          </ProgressModal>
        </ProgressOverlay>
      )}
      {bulkErrors.length > 0 && (
        <ModalWindow
          borderTop
          style={{ minWidth: '420px', maxWidth: '560px' }}
          onClickOutside={() => setBulkErrors([])}
        >
          <ContainerModal>
            <Flex flexDirection="column" style={{ gap: '16px', padding: '8px 0' }}>
              <ModalTitle style={{ color: '#D32F2F' }}>
                {`${bulkErrors.length} ${t('requisicoesComErro')}`}
              </ModalTitle>
              <ModalSubTitle>{t('osItensAbaixoNaoForamProcessados')}</ModalSubTitle>
              <div
                style={{
                  maxHeight: '240px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px',
                }}
              >
                {bulkErrors.map((wo) => (
                  <div
                    key={wo.WORK_ORDER_HIST_ID}
                    style={{
                      display: 'flex', flexDirection: 'column', padding: '8px 12px', background: '#FFF3F3', borderRadius: '6px', borderLeft: '3px solid #D32F2F', fontSize: '13px',
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>{wo.WORK_ORDER_HIST_WO_CODE || wo.DEVICE_CODE}</span>
                    <span style={{ color: '#555' }}>{`${wo.CLIENT_NAME} · ${wo.ASSET_NAME} · ${wo.DEVICE_CODE}`}</span>
                  </div>
                ))}
              </div>
              <Flex style={{ justifyContent: 'flex-end' }}>
                <Button variant="primary" onClick={() => setBulkErrors([])}>
                  {t('fechar')}
                </Button>
              </Flex>
            </Flex>
          </ContainerModal>
        </ModalWindow>
      )}
      {bulkRejectModal.open && (
        <ModalWindow
          borderTop
          style={{ minWidth: '420px', maxWidth: '520px' }}
          onClickOutside={() => setBulkRejectModal((prev) => ({ ...prev, open: false }))}
        >
          <ContainerModal>
            <Flex flexDirection="column" style={{ gap: '16px', padding: '8px 0' }}>
              <ModalTitle>{t('reprovarEmMassa')}</ModalTitle>
              <ModalSubTitle>
                {bulkRejectModal.type === 'alert' ? t('statusDoAlarme') : t('statusDaManutencao')}
                {' — '}
                {bulkRejectModal.type === 'alert'
                  ? state.selectedWorkOrders.filter((wo) => wo.WORK_ORDER_HIST_STATE_ID === 1).length
                  : state.selectedWorkOrders.filter((wo) => wo.WORK_ORDER_HIST_STATE_ID === 4 || wo.WORK_ORDER_HIST_STATE_ID === 9).length}
                {` ${t('selecionado(s)')}`}
              </ModalSubTitle>
              <TextArea
                label={t('descricao')}
                placeholder={t('adicioneUmaDescricao')}
                value={bulkRejectComment}
                onChange={(value) => setBulkRejectComment(value)}
                style={{ minHeight: '100px' }}
              />
              <Flex style={{ gap: '8px', justifyContent: 'flex-end' }}>
                <ModalCancel onClick={() => setBulkRejectModal((prev) => ({ ...prev, open: false }))}>
                  {t('cancelar')}
                </ModalCancel>
                <Button variant="primary" onClick={confirmBulkReject}>
                  {t('confirmar')}
                </Button>
              </Flex>
            </Flex>
          </ContainerModal>
        </ModalWindow>
      )}
      {isModalOpen && (
      <ModalWindow
        borderTop
        style={{
          minWidth: isDesktop ? '900px' : '300px',
          paddingLeft: '0',
          paddingRight: '0',
        }}
        onClickOutside={handleModalClose}
      >
        <ContainerModal>
          <Flex flexDirection="column">
            <Flex flexDirection="column" justifyContent="start">
              <ModalTitle>
                {
                  state.dataModalSelected?.MACHINE_NAME
                }
              </ModalTitle>
              <ModalSubTitle>
                {
                  state.dataModalSelected?.ASSET_NAME
                }
              </ModalSubTitle>
            </Flex>
            <Flex mt={10}>
              <Flex flexDirection="column" mr={32}>
                <ModalTextTitle>
                  {t('statusDaOS')}
                </ModalTextTitle>
                <ModalText>
                  {formatLabelStatus(state.dataModalSelected?.WORK_ORDER_HIST_STATE_ID)}
                </ModalText>
              </Flex>
              <Flex flexDirection="column" mr={32}>
                <ModalTextTitle>
                  {t('aberturaDaOS')}
                </ModalTextTitle>
                <ModalText>
                  {state.dataModalSelected?.WORK_ORDER_HIST_CREATED_WO ? moment(state.dataModalSelected?.WORK_ORDER_HIST_CREATED_WO).format('DD/MM/YYYY') : '\u00A0'}
                </ModalText>
              </Flex>
              <Flex flexDirection="column">
                <ModalTextTitle>
                  {t('fechamentoDaOS')}
                </ModalTextTitle>
                <ModalText>
                  {state.dataModalSelected?.WORK_ORDER_HIST_CLOSED_WO ? moment(state.dataModalSelected?.WORK_ORDER_HIST_CLOSED_WO).format('DD/MM/YYYY') : '\u00A0'}
                </ModalText>
              </Flex>
            </Flex>
          </Flex>
          <hr style={{ width: '100%', marginBottom: '10px' }} />
          <ContainerModalInputs>
            <Flex flexDirection="column" justifyContent="space-between">
              <ModalTextTitle>
                {t('cliente')}
              </ModalTextTitle>
              <ModalText>
                {state.dataModalSelected?.CLIENT_NAME}
              </ModalText>
            </Flex>
            <Flex flexDirection="column" justifyContent="space-between">
              <ModalTextTitle>
                {t('unidade')}
              </ModalTextTitle>
              <ModalText>
                {state.dataModalSelected?.UNIT_NAME}
              </ModalText>
            </Flex>
            <Flex flexDirection="column" justifyContent="space-between">
              <ModalTextTitle>
                {t('dispositivo')}
              </ModalTextTitle>
              <ModalText>
                {state.dataModalSelected?.DEVICE_CODE}
              </ModalText>
            </Flex>
            <Flex flexDirection="column" justifyContent="space-between">
              <ModalTextTitle>
                {t('saudeAtual')}
              </ModalTextTitle>
              <ModalText>
                {
                  HealthCell(state.dataModalSelected?.HEALTH_INDEX)
                }
              </ModalText>
            </Flex>
          </ContainerModalInputs>
          <ContainerModalInputs style={{ marginTop: '20px', flexDirection: 'column' }}>
            <ModalTextTitle>
              {t('historicoDeComentarios')}
            </ModalTextTitle>
            <Flex flexDirection="column" justifyContent="space-between">
              {state.commentsWorkOrder.Comments.map((comment) => (
                <Flex flexDirection="column" justifyContent="space-between" key={comment.ID}>
                  <ModalText style={{ marginTop: '10px' }}>
                    {moment(comment.CREATED_AT).format('DD/MM/YYYY')}
                    {' '}
                    -
                    {' '}
                    {comment.COMMENT_TEXT}
                    {' '}
                    -
                    {' '}
                    {comment.COMMENTED_BY}
                  </ModalText>
                </Flex>
              ))}
            </Flex>
          </ContainerModalInputs>
          {state.isEditModal && (
          <Flex width="100%" mt={40} flexDirection="column">
            <TextArea
              placeholder={t('descrevaOMotivoParaReprovarAManutenção')}
              label={t('descricao')}
              value={textComment}
              onChange={setTextComment}
            />
          </Flex>
          )}
        </ContainerModal>
        {state.isEditModal && (
          <Flex marginTop={20} marginLeft={30} marginRight={30} justifyContent="space-between" alignItems="end" flexDirection="row">
            <ModalCancel
              style={{
                cursor: 'pointer', textAlign: 'center', width: '100px',
              }}
              onClick={handleModalClose}
            >
              {t('botaoCancelar')}
            </ModalCancel>
            <Button
              onClick={() => handleSendComment(state.dataModalSelected)}
              variant="primary"
              style={{ width: '150px', fontWeight: 'normal' }}
            >
              {t('finalizar')}
            </Button>
          </Flex>
        )}
      </ModalWindow>
      )}
    </Container>
  );
};

const NoDataInTable = () => (
  <NoApiReturn style={{ minHeight: '60vh' }}>
    <NewApiIcon color="#7d7d7d" />
    <span>{t('listagemDeApi')}</span>
    <div style={{ width: '250px' }}>
      <p>
        {t('paraGerarListagemCadastrarNovaConfiguracao')}
      </p>
    </div>
  </NoApiReturn>
);
